<p-panel header="Help">
  If you are experiencing any issues, contact your administrators or us at
  <a href="mailto:calvin.nursing.emr@gmail.com">calvin.nursing.emr&#64;gmail.com</a>
  for help!
</p-panel>